import React from 'react';
import { Button } from 'antd';
import logoIcon from 'assets/img/login-elsa-logo-icon.svg';
import logoWordmark from 'assets/img/login-elsa-logo-wordmark.svg';
import './login.css';
import { useTranslation } from 'react-i18next';
import GlobalStore from 'stores/globalStore';
import { Helmet } from 'react-helmet';
import { getUniversalLoginUrl, getUniversalResetPasswordUrl } from 'utils/universal-login';

const Login: React.FC = () => {
  const { t } = useTranslation();
  const { currentLanguage } = GlobalStore.useContainer();

  return (
    <div className="signin-container">
      {currentLanguage === 'ja' ? (<Helmet>
        <title>ログイン - ELSA Speak アカウントにログイン</title>
        <meta
          name="description"
          content="ELSA Speak アカウントへのログイン方法をご案内します。アクティベーションコードの利用や、ELSA Pro・ELSA Premium・ELSA Professional へのプラン変更が行えます。"
        />
      </Helmet>) :
      <Helmet>
        <title>Login Account - ELSA Speak</title>
        <meta
          name="description"
          content="ELSA Speak App account login for web PC. Create new account. Redeem ELSA Premium, Oxford Business Result, ELSA for Students, free."
        />
      </Helmet>}
      <div className="logo">
        <div className="logo-mark">
          <img className="logo-mark-icon" alt="logo" src={logoIcon} />
          <img className="logo-mark-wordmark" alt="" src={logoWordmark} />
        </div>
      </div>
      <div className="form-container">
        <h1 className="login-title">{t('login.page_title')}</h1>
        <Button
          className="submit-button"
          onClick={() => {
            window.location.href = getUniversalLoginUrl();
          }}
        >
          {t('login.login')}
        </Button>
        <div className="form-login-footer">
          <a href={getUniversalResetPasswordUrl()}>
            <button className="footer-link" >{t('login.forgot_password')}</button>
          </a>
          <a href={getUniversalLoginUrl()}>
            <button className="footer-link" >
            {t('signup.signup')}
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
